import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import isNaN from 'lodash/isNaN';
import isEmpty from 'lodash/isEmpty';
import Icon from './Icon';

const StarRatingWrapper = styled<any, any>('div')`
    ${propStyles};
`;

StarRatingWrapper.defaultProps = {
    display: 'flex',
};

const StarIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

const StarOutlineIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarOutlineIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

interface StarRating {
    theme?: { [property: string]: string | number };
    showEmptyStars?: boolean;
    maxRating?: number;
    rating: number | string;
    display?: string;
    noDataPlaceholder?: string;
}

export const StarRating: React.SFC<StarRating> = ({
    theme,
    showEmptyStars,
    maxRating = 5,
    rating = 0,
    noDataPlaceholder,
    ...props
}) => {
    const ratingNumber = parseInt(rating as any, 10);
    const noDataPlaceholderElement = <Fragment>{noDataPlaceholder}</Fragment>;
    // If we are not able to get a number, display the rating value
    // In this case it is likely to be a no data placeholder
    if (isNaN(ratingNumber)) {
        // use placeholder if no rating or rating is empty
        if (noDataPlaceholder && !rating && isEmpty(rating)) {
            return noDataPlaceholderElement;
        }
        return <Fragment>{rating}</Fragment>;
    }

    // use placeholder if rating equals 0
    if (noDataPlaceholder && ratingNumber === 0) {
        return noDataPlaceholderElement;
    }

    const stars = Array.from(Array(ratingNumber).keys()).slice(0, maxRating);
    const emptyStars = showEmptyStars
        ? Array.from(Array(maxRating).keys())
        : [];

    return (
        <StarRatingWrapper {...props} {...theme.StarRatingWrapper}>
            {stars.map((r, i) => (
                <StarIcon
                    key={i}
                    fileName="MorningstarIcon"
                    {...theme.StarIcon}
                />
            ))}
            {emptyStars.slice(stars.length).map((s, i) => (
                <StarOutlineIcon
                    key={i}
                    fileName="MorningstarOutlineIcon"
                    {...theme.StarOutlineIcon}
                />
            ))}
        </StarRatingWrapper>
    );
};

export default observer(withTheme(StarRating));



// WEBPACK FOOTER //
// ./src/Components/StarRating.tsx